import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {equals} from 'ramda'
import Analytics from '..'

/**
 * This HOC fires SP event each time page# is changed.
 * @param {*} WrappedComponent Instance of @cred/react-pagination shared component
 */
const withAnalyticsOnPageChange = WrappedComponent =>
  class extends Component {
    static propTypes = {onChange: PropTypes.func.isRequired}

    static displayName = `${WrappedComponent.displayName}WithAnalyticsOnPageChange`

    constructor(props) {
      super(props)

      this.analytics = new Analytics(props.analytics)
    }

    componentDidUpdate(prevProps) {
      if (
        prevProps.analytics &&
        !equals(prevProps.analytics.contexts, this.props.analytics.contexts)
      ) {
        this.analytics = new Analytics(this.props.analytics)
      }
    }

    onChange = (name, page) => {
      const {onChange} = this.props

      onChange(name, page)

      this.analytics.event({

        // Click on disabled link doesn't call `onChange` callback at all so it's always activated
        activated: true,

        // Our pagination is zero-based but to track analytics we start page# from 1
        text: `${page + 1}`
      })
    }

    render() {
      const {onChange, ...props} = this.props

      return (
        <WrappedComponent
          onChange={this.onChange}
          {...props}
        />
      )
    }
  }

export default withAnalyticsOnPageChange
